import {i18n} from '@yourcoach/i18n';

export const getFoodDiaryTrackerUnitString = (unit?: string): string => {
  /**
   * @i18n_parser
   * t('shared:food_diary.nutrients_unit.g')
   * t('shared:food_diary.nutrients_unit.kcal')
   * t('shared:food_diary.nutrients_unit.mg')
   * t('shared:food_diary.nutrients_unit.µg')
   */
  return unit ? i18n.t(`shared:food_diary.nutrients_unit.${unit}`) : '';
};
